import { render, staticRenderFns } from "./module-bar.vue?vue&type=template&id=478d8d2a&scoped=true&"
import script from "./module-bar.vue?vue&type=script&lang=js&"
export * from "./module-bar.vue?vue&type=script&lang=js&"
import style0 from "./module-bar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./module-bar.vue?vue&type=style&index=1&id=478d8d2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478d8d2a",
  null
  
)

export default component.exports